import React from 'react';

function Pagination({
	page,
	setPage,
	totalPageNo,
}: {
	page: number;
	setPage: (p: number) => void;
	totalPageNo: number;
}) {
	const pageNeighbours = 1; // Number of page numbers to show before/after current page
	const totalPages = Math.max(1, totalPageNo);

	const getPageNumbers = () => {
		const startPage = Math.max(1, page - pageNeighbours);
		const endPage = Math.min(totalPages, page + pageNeighbours);
		const pages = [];

		if (startPage > 1) pages.push(1);
		if (startPage > 2) pages.push('...');

		for (let p = startPage; p <= endPage; p++) {
			pages.push(p);
		}

		if (endPage < totalPages - 1) pages.push('...');
		if (endPage < totalPages) pages.push(totalPages);

		return pages;
	};

	const pageNumbers = getPageNumbers();

	return (
		<div className='flex items-center justify-between border-t border-gray-200 bg-[#F8FAFB] px-4 py-3 sm:px-6'>
			<div className='hidden sm:flex sm:flex-1 sm:items-center sm:justify-center'>
				<nav className='isolate inline-flex -space-x-px rounded-md shadow-sm' aria-label='Pagination'>
					<button
						onClick={() => setPage(Math.max(1, page - 1))}
						disabled={page === 1}
						className='relative inline-flex items-center px-2 py-2 text-sm font-semibold text-gray-500  hover:bg-gray-50 disabled:opacity-50'
						aria-label='Previous Page'
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							strokeWidth={1.5}
							stroke='currentColor'
							className=' w-5 h-5'
						>
							<path strokeLinecap='round' strokeLinejoin='round' d='M15.75 19.5 8.25 12l7.5-7.5' />
						</svg>
					</button>
					{pageNumbers.map((p, idx) =>
						typeof p === 'number' ? (
							<button
								key={p}
								onClick={() => setPage(p)}
								className={`relative cursor-pointer z-10 inline-flex items-center px-4 py-2 text-sm font-semibold focus:z-20 ${
									p === page ? 'bg-indigo-600 text-white' : 'text-gray-700 bg-white hover:bg-gray-50'
								}`}
								aria-current={p === page ? 'page' : undefined}
							>
								{p}
							</button>
						) : (
							<span key={`${p}-${idx}`} className='inline-flex items-center px-4 py-2 text-sm text-gray-400'>
								{p}
							</span>
						),
					)}
					<button
						onClick={() => setPage(Math.min(totalPages, page + 1))}
						disabled={page === totalPages}
						className='relative inline-flex items-center px-2 py-2 text-sm font-semibold text-gray-500  hover:bg-gray-50 disabled:opacity-50'
						aria-label='Next Page'
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							strokeWidth={1.5}
							stroke='currentColor'
							className=' w-5 h-5'
						>
							<path strokeLinecap='round' strokeLinejoin='round' d='m8.25 4.5 7.5 7.5-7.5 7.5' />
						</svg>
					</button>
				</nav>
			</div>
		</div>
	);
}

export default Pagination;
